import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/app/src/components/Breadcrumb/Breadcrumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DiscoverPage"] */ "/app/src/components/DiscoverPage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/src/components/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageScaffold"] */ "/app/src/components/PageScaffold/index.tsx");
